<div class="wb-container">

  <!-- Tabs -->
  @if (config.showAdvisories.length > 1) {
    <ul class="wb-tabs">
      @if (showTab('wq')) {
        <li>
          <button [class.active]="activeTab === 'wq'" (click)="selectTab('wq')">Water Quality</button>
        </li>
      }
      @if (showTab('cso')) {
        <li>
          <button [class.active]="activeTab === 'cso'" (click)="selectTab('cso')">Combined Sewer Overflows</button>
        </li>
      }
    </ul>
  }

  <!-- Legend -->
  @if (activeTab === 'cso') {
    <div class="wb-legend">
      <span class="legend-label">CSO Volume:</span>
      @for (r of CSO_RANGES; track r.label) {
        <span class="legend-dot" [style.background]="r.color" [style.border]="r.color === '#FFFF00' || r.color === '#90EE90' ? '1px solid #aaa' : 'none'"></span>
        <span>{{ r.label }}</span>
      }
    </div>
  } @else {
    <div class="wb-legend">
      <span class="legend-label">Legend:</span>
      <span class="legend-dot advisory"></span><span class="legend-text advisory">On Advisory</span>
      <span class="legend-dot no-advisory"></span><span class="legend-text no-advisory">No Advisory</span>
    </div>
  }

  <!-- Toolbar -->
  <div class="wb-toolbar">
    <span class="wb-title">Waterbodies</span>
    <input type="search" placeholder="Type a water body" [(ngModel)]="keyword" />
    <label class="advisory-filter">
      <input type="checkbox" [(ngModel)]="onAdvisoryOnly" /> Show advisory only
    </label>
    <button class="btn-reset" (click)="reset()">Reset</button>
  </div>

  <!-- Loading / Error -->
  @if (isLoading) {
    <div class="wb-status">Loading...</div>
  }
  @if (errorMessage) {
    <div class="wb-status error">{{ errorMessage }}</div>
  }

  <!-- List -->
  @if (!isLoading) {
    <div class="wb-list">
      @for (wb of filteredWaterBodies; track wb.id; let i = $index) {
        <div class="wb-row" (click)="selectWaterBody(wb)" style="cursor: pointer;">
          <div class="wb-info">
            <span class="wb-indicator" [class.on-advisory]="wb.hasAdvisory" [class.no-advisory]="!wb.hasAdvisory"></span>
            <span class="wb-name">{{ i + 1 }}. <strong>{{ wb.name | uppercase }}</strong> &mdash; Class {{wb.class}}
              @if (getWaterClassInfo(wb.class)) {
                <button
                  class="class-badge"
                  type="button"
                  (click)="toggleClassInfo(wb, $event)"
                  [attr.aria-expanded]="activeInfoId === wb.id"
                  [attr.aria-label]="'Water class info for ' + wb.class">
                  <span class="class-badge-icon">i</span>
                </button>
              } @else {
                <span><strong>Class {{ wb.class }}</strong></span>
              }
              &mdash;
              @if (wb.hasAdvisory && wb.advisory) {
                <span class="advisory-text"><strong>on advisory until {{ wb.advisory.until | date: 'MMM dd, hh:mm a' }}</strong></span>
              } @else {
                <strong style="color: rgb(65, 105, 225)">No Advisory</strong>
              }
            </span>
            @if (wb.rainGauge) {
              <span class="wb-sensor">{{ wb.rainGauge }}</span>
            }
          </div>

          @if (activeInfoId === wb.id && getWaterClassInfo(wb.class)) {
            <div class="class-popup-row">
              <div class="class-popup">
                <strong>{{ getWaterClassInfo(wb.class)!.label }}</strong>
                <p>{{ getWaterClassInfo(wb.class)!.description }}</p>
              </div>
            </div>
          }

          @if (wb.hasAdvisory && wb.advisory) {
            <div class="wb-progress-track">
              <div class="wb-progress-bar" [style.width.%]="progressPercent(wb)" [style.background]="activeTab === 'cso' ? csoBarColor(wb) : null">
                {{ wb.advisory.hours | number: '1.0-0' }}&nbsp;hours left
              </div>
            </div>
          } @else {
            <div class="wb-progress-track"></div>
          }
        </div>
      }

      @if (filteredWaterBodies.length === 0 && !isLoading && !errorMessage) {
        <div class="wb-status">No water bodies match your filter.</div>
      }
    </div>
  }

</div>
